
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2PQ94", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $2TjtA = parcelRequire("2TjtA");

const $8732b95d75640165$export$91aed7d8dfc4aa1f = (props)=>{
    const $ = (0, $bDgLe.c)(15);
    const t0 = props.node?.localId;
    let t1;
    if ($[0] !== props.contentId || $[1] !== t0) {
        t1 = {
            contentId: props.contentId,
            nodeLocalId: t0
        };
        $[0] = props.contentId;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== props.clientAnnotationProvider || $[4] !== props.clientExtensionHandlers || $[5] !== props.clientHydrationReady || $[6] !== props.contentId || $[7] !== props.contentMode || $[8] !== props.enableHydrationBridge || $[9] !== props.extensionHandlers || $[10] !== props.node) {
        t2 = props.enableHydrationBridge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2TjtA.NBMRendererHydrationBridge), {
            clientAnnotationProvider: props.clientAnnotationProvider,
            clientExtensionHandlers: props.clientExtensionHandlers,
            clientHydrationReady: props.clientHydrationReady,
            contentId: props.contentId,
            contentMode: props.contentMode,
            extensionHandlers: props.extensionHandlers,
            node: props.node
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2TjtA.NBMRendererServer), {
            contentId: props.contentId,
            contentMode: props.contentMode,
            node: props.node
        });
        $[3] = props.clientAnnotationProvider;
        $[4] = props.clientExtensionHandlers;
        $[5] = props.clientHydrationReady;
        $[6] = props.contentId;
        $[7] = props.contentMode;
        $[8] = props.enableHydrationBridge;
        $[9] = props.extensionHandlers;
        $[10] = props.node;
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[12] !== t1 || $[13] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).BACKBONE,
            attributes: t1
        }, t2);
        $[12] = t1;
        $[13] = t2;
        $[14] = t3;
    } else t3 = $[14];
    return t3;
};
module.exports["LegacyContentExtensionHandler"] = $8732b95d75640165$export$91aed7d8dfc4aa1f;

});

parcelRegister("gmxua", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $ep3mz = parcelRequire("ep3mz");





var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $eNbr2 = parcelRequire("eNbr2");


var $jNKuq = parcelRequire("jNKuq");


var $8Ij3v = parcelRequire("8Ij3v");


var $hMRhJ = parcelRequire("hMRhJ");


var $2TjtA = parcelRequire("2TjtA");


var $hBmKH = parcelRequire("hBmKH");


var $iy2dR = parcelRequire("iy2dR");


var $KndLU = parcelRequire("KndLU");


var $gGHFp = parcelRequire("gGHFp");





var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");


var $cLo2u = parcelRequire("cLo2u");

const $747431ca82b27ac2$export$752c2a143fc251c1 = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { contentMode: contentMode, node: node } = props;
    // Inside a bridged recursive-SSR subtree this LCM is already within a renderer that holds the
    // manifests, so it inherits them instead of building and populating a factory of its own. On a
    // client-only page or an SPA transition there is nothing to inherit and it keeps its own.
    const insideNestedLcmHierarchy = (0, $cozmU.useContext)((0, $hBmKH.NestedLcmHierarchyContext));
    const spaceId = (0, $7QM6o.useSpaceId)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType = 'page'] = (0, $ep3mz.useContentType)();
    const { environment: environment, cloudId: cloudId, userId: userId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { getExtensionHandlers: getExtensionHandlers, populateExtensionProviders: populateExtensionProviders } = (0, $cozmU.useContext)((0, $hMRhJ.RendererExtensionContext));
    // A child of the ambient factory rather than the factory itself: `mergeDataProviders` mutates
    // whatever it is given, so reusing the page factory directly would swap the page's own
    // media/card/task providers and notify every subscriber on the page.
    const derivedProviderFactory = (0, $KndLU.useNestedLcmProviderFactory)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    const { mode: editorContentMode } = (0, $gGHFp.useEditorContentModeValue)({
        contentId: contentId
    });
    const effectiveContentMode = contentMode ?? editorContentMode;
    const { adfDocument: adfDocument, appearance: appearance } = (0, $2TjtA.resolveNBMRenderConfig)(node);
    /**
   * Both context functions use classic renderer types that are currently exposed as `any`.
   */ const extensionHandlers = (0, $cozmU.useMemo)(()=>getExtensionHandlers?.({
            adf: adfDocument,
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType,
            appearance: 'full-width',
            referentialityDataSourceProvider: {}
        }, createAnalyticsEvent), [
        adfDocument,
        contentId,
        contentType,
        createAnalyticsEvent,
        getExtensionHandlers,
        spaceKey
    ]);
    const annotationProvider = (0, $8Ij3v.useRendererAnnotationProviderOptions)({
        pageId: contentId ?? '',
        validAnnotationsCallback: ()=>{},
        triggerAnalyticsEvent: createAnalyticsEvent,
        updateDocument: ()=>{},
        isArchived: false
    });
    const getDataProviders = (0, $cozmU.useCallback)(()=>{
        const providerFactory = (0, $eNbr2.default).create({});
        if (populateExtensionProviders) populateExtensionProviders(providerFactory, {
            activationId: activationId,
            accountId: userId,
            cloudId: cloudId,
            containerId: spaceKey,
            contentId: contentId,
            contentType: contentType,
            createAnalyticsEvent: createAnalyticsEvent,
            environment: environment,
            extensionHandlers: extensionHandlers,
            intl: intl,
            spaceKey: spaceKey,
            spaceId: spaceId
        });
        return providerFactory;
    }, [
        populateExtensionProviders,
        activationId,
        userId,
        cloudId,
        spaceKey,
        contentId,
        contentType,
        createAnalyticsEvent,
        environment,
        extensionHandlers,
        intl,
        spaceId
    ]);
    const { eventHandlers: eventHandlers, onSetLinkTarget: onSetLinkTarget } = (0, $jNKuq.useExternalLinkHandlers)();
    (0, $iy2dR.useLegacyContentMacroRendererAnalytics)({
        adfDocument: adfDocument,
        contentId: contentId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2TjtA.NBMRendererContent), {
        allowAnnotations: true,
        annotationProvider: annotationProvider,
        appearance: appearance,
        contentId: contentId,
        contentMode: effectiveContentMode,
        dataProviders: insideNestedLcmHierarchy ? derivedProviderFactory : getDataProviders(),
        adfDocument: adfDocument,
        eventHandlers: eventHandlers,
        onSetLinkTarget: onSetLinkTarget
    });
});


const $90e09e5972c02f7f$export$91aed7d8dfc4aa1f = (props)=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).CC_EDITOR_AI,
        attributes: {
            contentId: contentId,
            nodeLocalId: props.node?.localId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $747431ca82b27ac2$export$752c2a143fc251c1), {
        contentMode: props.contentMode,
        node: props.node
    }));
};
module.exports["LegacyContentExtensionHandler"] = $90e09e5972c02f7f$export$91aed7d8dfc4aa1f;

});

parcelRegister("8Ij3v", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jzubZ = parcelRequire("jzubZ");


var $cZa7r = parcelRequire("cZa7r");


var $9zMAu = parcelRequire("9zMAu");


var $ikqOG = parcelRequire("ikqOG");

const $0880ee54bb9fbae3$export$8a100b863f90f2c5 = ({ pageId: pageId, validAnnotationsCallback: validAnnotationsCallback, triggerAnalyticsEvent: triggerAnalyticsEvent, updateDocument: updateDocument, isArchived: isArchived })=>{
    const { setSelectionProps: setSelectionProps, setViewProps: setViewProps, setHoverProps: setHoverProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const annotationManager = (0, $cZa7r.useAnnotationManager)();
    const { reactionMarkerRefs: reactionMarkerRefs, reactionMarkerMap: reactionMarkerMap } = (0, $9zMAu.useActiveInlineData)(pageId);
    const { mergedReactionMarkerRefs: mergedReactionMarkerRefs, mergedReactionMarkerMap: mergedReactionMarkerMap, optimisticResolvedMarkerRefs: optimisticResolvedMarkerRefs } = (0, $ikqOG.useInlineReactionMarkers)({
        reactionMarkerRefs: reactionMarkerRefs,
        reactionMarkerMap: reactionMarkerMap
    });
    // Keep refs so the getters always return the latest merged values,
    // even if the renderer calls an old getState/viewComponent closure before
    // it receives the new annotationProvider prop. Crucially, these stable
    // getters are NOT in the useMemo deps — so a change to mergedReactionMarkerRefs
    // or mergedReactionMarkerMap alone does NOT create a new annotationProvider
    // options object. Without this, any optimistic reaction add/remove would
    // trigger a new options object → renderer re-initialises → async getState gap
    // → resolved highlight briefly snaps back to ACTIVE (CCCEMAU-2679).
    const reactionMarkerRefsRef = (0, $cozmU.useRef)(mergedReactionMarkerRefs);
    reactionMarkerRefsRef.current = mergedReactionMarkerRefs;
    const getReactionMarkerRefs = (0, $cozmU.useCallback)(()=>reactionMarkerRefsRef.current, []);
    const reactionMarkerMapRef = (0, $cozmU.useRef)(mergedReactionMarkerMap);
    reactionMarkerMapRef.current = mergedReactionMarkerMap;
    const getReactionMarkerMap = (0, $cozmU.useCallback)(()=>reactionMarkerMapRef.current, []);
    const optimisticResolvedMarkerRefsRef = (0, $cozmU.useRef)(optimisticResolvedMarkerRefs);
    optimisticResolvedMarkerRefsRef.current = optimisticResolvedMarkerRefs;
    const getOptimisticResolvedMarkerRefs = (0, $cozmU.useCallback)(()=>optimisticResolvedMarkerRefsRef.current, []);
    return (0, $cozmU.useMemo)(()=>({
            inlineComment: (0, $jzubZ.getRendererInlineCommentOptions)({
                pageId: pageId,
                validAnnotationsCallback: validAnnotationsCallback,
                triggerAnalyticsEvent: triggerAnalyticsEvent,
                setSelectionProps: setSelectionProps,
                setHoverProps: setHoverProps,
                setViewProps: setViewProps,
                updateDocument: updateDocument,
                isArchived: isArchived,
                getReactionMarkerRefs: getReactionMarkerRefs,
                getReactionMarkerMap: getReactionMarkerMap,
                getOptimisticResolvedMarkerRefs: getOptimisticResolvedMarkerRefs
            }),
            annotationManager: annotationManager
        }), [
        pageId,
        validAnnotationsCallback,
        triggerAnalyticsEvent,
        setSelectionProps,
        setHoverProps,
        setViewProps,
        updateDocument,
        isArchived,
        annotationManager,
        getReactionMarkerRefs,
        getReactionMarkerMap,
        getOptimisticResolvedMarkerRefs
    ]);
};
module.exports["useRendererAnnotationProviderOptions"] = $0880ee54bb9fbae3$export$8a100b863f90f2c5;

});

parcelRegister("jzubZ", function(module, exports) {

var $gczDe = parcelRequire("gczDe");


var $hXzKU = parcelRequire("hXzKU");


var $kDIns = parcelRequire("kDIns");


var $7AfoH = parcelRequire("7AfoH");


var $ayqMG = parcelRequire("ayqMG");


var $dQXFR = parcelRequire("dQXFR");

const $6c72ee9a775e4c5b$export$e5e59df64f812c64 = ({ pageId: pageId, validAnnotationsCallback: validAnnotationsCallback, triggerAnalyticsEvent: triggerAnalyticsEvent, setSelectionProps: setSelectionProps, setViewProps: setViewProps, updateDocument: updateDocument, isArchived: isArchived, setHoverProps: setHoverProps, getReactionMarkerRefs: getReactionMarkerRefs, getReactionMarkerMap: getReactionMarkerMap, getOptimisticResolvedMarkerRefs: getOptimisticResolvedMarkerRefs })=>{
    let updateSubscriber = (0, $gczDe.getRendererAnnotationEventEmitter)();
    if (!updateSubscriber?.off) updateSubscriber = undefined;
    return {
        selectionComponent: (0, $7AfoH.SelectionManager)({
            pageId: pageId,
            updateDocument: updateDocument,
            isArchived: isArchived,
            setSelectionProps: setSelectionProps,
            onCommentButtonMount: ()=>(0, $hXzKU.LazyCommentEditor).preload()
        }),
        viewComponent: (0, $ayqMG.ViewManager)({
            pageId: pageId,
            updateDocument: updateDocument,
            isArchived: isArchived,
            setViewProps: setViewProps,
            getReactionMarkerMap: getReactionMarkerMap
        }),
        hoverComponent: (0, $dQXFR.HoverManager)({
            pageId: pageId,
            updateDocument: updateDocument,
            isArchived: isArchived,
            setHoverProps: setHoverProps,
            onCommentButtonMount: ()=>(0, $hXzKU.LazyCommentEditor).preload()
        }),
        getState: (annotations, isNestedRender)=>{
            const reactionMarkerRefs = getReactionMarkerRefs?.();
            const optimisticResolvedMarkerRefs = getOptimisticResolvedMarkerRefs?.();
            return (0, $kDIns.getRendererAnnotationStates)({
                annotations: annotations,
                pageId: pageId,
                validAnnotationsCallback: validAnnotationsCallback,
                triggerAnalyticsEvent: triggerAnalyticsEvent,
                isNestedRender: isNestedRender,
                reactionMarkerRefs: // Always call the getter at execution time so resolved highlights don't reappear
                // when the renderer calls a stale getState closure (CCCEMAU-2679).
                reactionMarkerRefs,
                optimisticResolvedMarkerRefs: optimisticResolvedMarkerRefs
            });
        },
        updateSubscriber: updateSubscriber,
        disallowOnWhitespace: true,
        isToolbarAbove: true,
        allowDraftMode: true,
        allowCommentsOnMedia: true
    };
};
module.exports["getRendererInlineCommentOptions"] = $6c72ee9a775e4c5b$export$e5e59df64f812c64;

});

parcelRegister("hXzKU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");


var $jmjWc = parcelRequire("jmjWc");


var $jnVM5 = parcelRequire("jnVM5");


const $7b7af88805418522$export$b355deaeb7ea7f7c = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "2kww5",
    name: "LazyCommentEditor",
    loader: async ()=>(await (parcelRequire("hAypH"))).CommentEditor,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "medium",
            interactionName: "comment-editor-loadable"
        })),
    waitForNetworkOnline: true
});

const $7b7af88805418522$export$301ffca6e2410600 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Pf9d2",
    name: "LazyInlineCommentEditor",
    loader: async ()=>(await (parcelRequire("hAypH"))).CommentEditor,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jnVM5.LazyCommentEditorPlaceholder), null),
    waitForNetworkOnline: true
});

const $7b7af88805418522$export$b728c0889ff2145f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "DmrQC",
    name: "LazyCommentEditorWithoutSpinner",
    loader: async ()=>(await (parcelRequire("hAypH"))).CommentEditor,
    waitForNetworkOnline: true
});
module.exports["LazyCommentEditor"] = $7b7af88805418522$export$b355deaeb7ea7f7c;
module.exports["LazyInlineCommentEditor"] = $7b7af88805418522$export$301ffca6e2410600;
module.exports["LazyCommentEditorWithoutSpinner"] = $7b7af88805418522$export$b728c0889ff2145f;

});

parcelRegister("jnVM5", function(module, exports) {
/* LazyCommentEditorPlaceholder.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8e8d5100a3bfca53$var$InputContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYE1Y8M _30huDKOeNX _0bjKvDzXzM _2sNsIgmnOE _0jFU0VuNcX _24h04i2Njc _39xV02N91d",
            __cmplp.className
        ])
    });
});
const $8e8d5100a3bfca53$export$b85a78dfaafd1a99 = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8e8d5100a3bfca53$var$InputContainer, {
        disabled: true,
        placeholder: intl.formatMessage({
            id: "comment.reply.placeholder",
            defaultMessage: "Reply"
        })
    }));
};
module.exports["LazyCommentEditorPlaceholder"] = $8e8d5100a3bfca53$export$b85a78dfaafd1a99;

});

parcelRegister("hAypH", function(module, exports) {

let $cce07e45d4f8cb6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cce07e45d4f8cb6f$var$load("kT6dz"),
    $cce07e45d4f8cb6f$var$load("ksOjm"),
    $cce07e45d4f8cb6f$var$load("jAsJw"),
    $cce07e45d4f8cb6f$var$load("1IYtR"),
    $cce07e45d4f8cb6f$var$load("cqZbj"),
    $cce07e45d4f8cb6f$var$load("gCuOv"),
    $cce07e45d4f8cb6f$var$load("evJG0"),
    $cce07e45d4f8cb6f$var$load("duumh"),
    $cce07e45d4f8cb6f$var$load("cVq6e"),
    $cce07e45d4f8cb6f$var$load("6wiGY"),
    $cce07e45d4f8cb6f$var$load("hUbK8"),
    $cce07e45d4f8cb6f$var$load("6wr18"),
    $cce07e45d4f8cb6f$var$load("aIRI1"),
    $cce07e45d4f8cb6f$var$load("ba41x"),
    $cce07e45d4f8cb6f$var$load("9Oxea"),
    $cce07e45d4f8cb6f$var$load("50OoB"),
    $cce07e45d4f8cb6f$var$load("da1f1"),
    $cce07e45d4f8cb6f$var$load("9q6b6"),
    $cce07e45d4f8cb6f$var$load("4vkBl"),
    $cce07e45d4f8cb6f$var$load("5Rwqt"),
    $cce07e45d4f8cb6f$var$load("8jxWu"),
    $cce07e45d4f8cb6f$var$load("6ZFWM"),
    $cce07e45d4f8cb6f$var$load("fNwGw"),
    $cce07e45d4f8cb6f$var$load("2j57H"),
    $cce07e45d4f8cb6f$var$load("ke023"),
    $cce07e45d4f8cb6f$var$load("2mGc6"),
    $cce07e45d4f8cb6f$var$load("b4OQl"),
    $cce07e45d4f8cb6f$var$load("h5t0Y"),
    $cce07e45d4f8cb6f$var$load("d19Pa"),
    $cce07e45d4f8cb6f$var$load("egqJx"),
    $cce07e45d4f8cb6f$var$load("2gzeE"),
    $cce07e45d4f8cb6f$var$load("glZF7"),
    $cce07e45d4f8cb6f$var$load("4dKZ4"),
    $cce07e45d4f8cb6f$var$load("7SteV"),
    $cce07e45d4f8cb6f$var$load("aoox2"),
    $cce07e45d4f8cb6f$var$load("2m7e4"),
    $cce07e45d4f8cb6f$var$load("k72sK"),
    $cce07e45d4f8cb6f$var$load("kD76L"),
    $cce07e45d4f8cb6f$var$load("eNgZ8"),
    $cce07e45d4f8cb6f$var$load("lAHCT"),
    $cce07e45d4f8cb6f$var$load("agVmZ"),
    $cce07e45d4f8cb6f$var$load("dxcsb"),
    $cce07e45d4f8cb6f$var$load("dZYhM"),
    $cce07e45d4f8cb6f$var$load("VXbA1"),
    $cce07e45d4f8cb6f$var$load("9cxGI"),
    $cce07e45d4f8cb6f$var$load("3wf3h"),
    $cce07e45d4f8cb6f$var$load("gBrSK"),
    $cce07e45d4f8cb6f$var$load("13lqP"),
    $cce07e45d4f8cb6f$var$load("eGnZE"),
    $cce07e45d4f8cb6f$var$load("lwTz1"),
    $cce07e45d4f8cb6f$var$load("kyAJ3"),
    $cce07e45d4f8cb6f$var$load("21HSP"),
    $cce07e45d4f8cb6f$var$load("1qlDN"),
    $cce07e45d4f8cb6f$var$load("1yVM6"),
    $cce07e45d4f8cb6f$var$load("jSV6e"),
    $cce07e45d4f8cb6f$var$load("6iimb"),
    $cce07e45d4f8cb6f$var$load("ffEVr"),
    $cce07e45d4f8cb6f$var$load("cdiJX"),
    $cce07e45d4f8cb6f$var$load("foA2q"),
    $cce07e45d4f8cb6f$var$load("8TYN0"),
    $cce07e45d4f8cb6f$var$load("Wowvf"),
    $cce07e45d4f8cb6f$var$load("29XrG"),
    $cce07e45d4f8cb6f$var$load("1JeTB"),
    $cce07e45d4f8cb6f$var$load("hhss7"),
    $cce07e45d4f8cb6f$var$load("7EorR"),
    $cce07e45d4f8cb6f$var$load("8Ovry")
]).then(()=>parcelRequire('3qEAL'));

});

parcelRegister("7AfoH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $dc72366b6b9218cc$export$6c8a5aaad13c9852 = ({ pageId: pageId, isArchived: isArchived, setSelectionProps: setSelectionProps, updateDocument: updateDocument, onCommentButtonMount: onCommentButtonMount })=>/*#__PURE__*/ (0, $cozmU.memo)((props)=>{
        const { range: range, draftRange: draftRange, wrapperDOM: wrapperDOM, isAnnotationAllowed: isAnnotationAllowed, onCreate: onCreate, onClose: onClose, applyDraftMode: applyDraftMode, removeDraftMode: removeDraftMode, inlineNodeTypes: inlineNodeTypes } = props;
        // Keep refs to applyDraftMode/removeDraftMode so that setSelectionOptionsForCreateEditor
        // always calls the latest Mounter instance's callbacks, even if Mounter unmounts and
        // remounts (e.g. after promoteHoverToDraft clears the type) without range/draftRange
        // changing (COMMENTS-6594).
        const applyDraftModeRef = (0, $cozmU.useRef)(applyDraftMode);
        const removeDraftModeRef = (0, $cozmU.useRef)(removeDraftMode);
        (0, $cozmU.useLayoutEffect)(()=>{
            applyDraftModeRef.current = applyDraftMode;
            removeDraftModeRef.current = removeDraftMode;
        }, [
            applyDraftMode,
            removeDraftMode
        ]);
        (0, $cozmU.useEffect)(()=>{
            setSelectionProps({
                pageId: pageId,
                isArchived: isArchived,
                updateDocument: updateDocument,
                range: range,
                draftRange: draftRange,
                wrapperDOM: wrapperDOM,
                isAnnotationAllowed: isAnnotationAllowed,
                onCreate: onCreate,
                onClose: onClose,
                applyDraftMode: (...args)=>applyDraftModeRef.current?.(...args),
                removeDraftMode: ()=>removeDraftModeRef.current?.(),
                inlineNodeTypes: inlineNodeTypes,
                onCommentButtonMount: onCommentButtonMount
            });
        // We only want to listen to changes that signifies a new selection
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            range,
            draftRange,
            wrapperDOM
        ]);
        return null;
    });
module.exports["SelectionManager"] = $dc72366b6b9218cc$export$6c8a5aaad13c9852;

});

parcelRegister("ayqMG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bSvtO = parcelRequire("bSvtO");


var $8aF6s = parcelRequire("8aF6s");


var $cMvMc = parcelRequire("cMvMc");


var $cZa7r = parcelRequire("cZa7r");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $9wGTI = parcelRequire("9wGTI");

const $913e742c4c6d0363$export$76599b5777b5fa44 = ({ pageId: pageId, updateDocument: updateDocument, setViewProps: setViewProps, isArchived: isArchived, annotations: annotations, clickElementTarget: clickElementTarget, deleteAnnotation: deleteAnnotation, getInlineNodeTypes: getInlineNodeTypes, getReactionMarkerMap: getReactionMarkerMap })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const reactionMarkerMap = getReactionMarkerMap?.();
    const { newlyCreatedAnnotationId: newlyCreatedAnnotationId, storedCommentData: storedCommentData } = (0, $cZa7r.useAnnotations)();
    const { handleClose: handleSelectionClose, setNewlyCreatedAnnotationId: setNewlyCreatedAnnotationId, clearStoredCommentData: clearStoredCommentData } = (0, $cZa7r.useAnnotationsDispatch)();
    // Clear stored comment data when annotation changes (before new component renders)
    (0, $cozmU.useEffect)(()=>{
        if (storedCommentData) {
            const currentAnnotationId = annotations?.[0]?.id;
            const storedAnnotationId = storedCommentData?.location?.inlineMarkerRef;
            // Clear stored data if we're viewing a different annotation
            if (currentAnnotationId && storedAnnotationId && currentAnnotationId !== storedAnnotationId) clearStoredCommentData();
        }
    }, [
        annotations,
        storedCommentData,
        clearStoredCommentData
    ]);
    (0, $cozmU.useEffect)(()=>{
        const wasHighlightClicked = Boolean(annotations.length && clickElementTarget);
        const handleSetViewProps = ()=>{
            // Below logic has been added to prevent the nested renderers like
            // excerpt/page properties macros to not set the wrong value of isArchived.
            // Thus, we need to setViewProps only when the "PageStatusQuery" defined in ViewPageComponent resolves
            if (isArchived !== undefined) setViewProps({
                pageId: pageId,
                updateDocument: updateDocument,
                isArchived: isArchived,
                annotations: annotations,
                clickElementTarget: clickElementTarget,
                deleteAnnotation: deleteAnnotation,
                wasHighlightClicked: wasHighlightClicked,
                getInlineNodeTypes: getInlineNodeTypes,
                reactionMarkerMap: reactionMarkerMap
            });
            // If we're showing this coming from a newly created comment, clear the props and succeed the experience
            if (annotations.length && annotations[0].id === newlyCreatedAnnotationId) {
                setNewlyCreatedAnnotationId(undefined);
                experienceTracker.succeed({
                    name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE)
                });
            }
        };
        // the if will be replaced with the new preemptive gate next/packages/annotation-provider-inline-comments/src/hooks/usePreemptiveGate.ts when cleanup platform_editor_comments_api_manager
        if (hasContentChanged && wasHighlightClicked && !(0, $9wGTI.fg)('platform_editor_comments_api_manager')) {
            let abortedKeyboardExperience = false;
            const experienceState = experienceTracker.getExperienceState((0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE));
            /*
       * If a keyboard shortcut is used to navigate when the content has changed, we abort and restart
       * the experience on confirm because we can't predict if the user will confirm the navigation, or
       * how long the user will take to confirm.
       */ if (experienceState !== null && experienceState?.hasStopped === false && experienceState?.attributes?.entryPoint === 'comments-shortcuts/ViewCommentShortcutListener') {
                experienceTracker.abort({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    reason: 'Comment warning dialog displayed',
                    checkForTimeout: true,
                    publishDebugPoints: true,
                    attributes: {
                        stopPoint: 'annotation-provider-inline-comments/renderer/ViewManager'
                    }
                });
                abortedKeyboardExperience = true;
            }
            showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    if (abortedKeyboardExperience) {
                        experienceTracker.start({
                            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                            timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                            attributes: {
                                annotationId: annotations.length && annotations[0].id,
                                entryPoint: 'annotation-provider-inline-comments/renderer/ViewManager',
                                pageClass: 'renderer'
                            }
                        });
                        experienceTracker.attachDebugPoint({
                            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                            message: 'Restarting experience after comment was discarded from comment warning dialog. Initial entrypoint: comments-shortcuts/ViewCommentShortcutListener'
                        });
                    }
                    resetContentChanged();
                    handleSelectionClose();
                    handleSetViewProps();
                }
            });
        } else handleSetViewProps();
    // We only want to listen to changes that signifies a new comment click
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        annotations,
        clickElementTarget
    ]);
    return null;
};
const $913e742c4c6d0363$export$e2fb22396d3bf4b8 = ({ pageId: pageId, updateDocument: updateDocument, setViewProps: setViewProps, isArchived: isArchived, getReactionMarkerMap: getReactionMarkerMap })=>/*#__PURE__*/ (0, $cozmU.memo)((viewComponentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($913e742c4c6d0363$export$76599b5777b5fa44, {
            pageId: pageId,
            updateDocument: updateDocument,
            setViewProps: setViewProps,
            isArchived: isArchived,
            getReactionMarkerMap: getReactionMarkerMap,
            ...viewComponentProps
        }));
module.exports["ViewManager"] = $913e742c4c6d0363$export$e2fb22396d3bf4b8;

});

parcelRegister("bSvtO", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $45ca38ec521afdf7$var$initialState = {
    hasContentChanged: false,
    isCommentContentReady: false
};
const $45ca38ec521afdf7$export$53ac33307b5acee9 = ()=>({
        hasContentChanged: false,
        isCommentContentReady: false
    });
const $45ca38ec521afdf7$export$e324594224ef24da = {
    onChange: (hasChanges)=>({ setState: setState })=>{
            setState({
                hasContentChanged: hasChanges
            });
        },
    resetContentChanged: ()=>({ setState: setState })=>{
            setState({
                hasContentChanged: false
            });
        },
    onCommentContentReady: ()=>({ setState: setState })=>{
            setState({
                isCommentContentReady: true
            });
        }
};
const $45ca38ec521afdf7$var$CommentsContentStore = (0, $8s9DV.createStore)({
    initialState: $45ca38ec521afdf7$var$initialState,
    actions: $45ca38ec521afdf7$export$e324594224ef24da,
    name: 'CommentsContentStore'
});
const $45ca38ec521afdf7$export$ef1bfc0b6758ca67 = (0, $kBr4q.createHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$e2038e591f93e866 = (0, $kBr4q.createActionsHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$1756d05b0495e6b = (0, $kBr4q.createStateHook)($45ca38ec521afdf7$var$CommentsContentStore);
module.exports["useCommentsContentActions"] = $45ca38ec521afdf7$export$e2038e591f93e866;
module.exports["useCommentsContentState"] = $45ca38ec521afdf7$export$1756d05b0495e6b;

});

parcelRegister("cMvMc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f2899d935411e961$export$fb31a121515f224d = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "_Vqh0",
    name: "CommentWarningDialog",
    loader: async ()=>(await (parcelRequire("7NKS7"))).CommentWarningDialog
});
module.exports["CommentWarningDialog"] = $f2899d935411e961$export$fb31a121515f224d;

});

parcelRegister("7NKS7", function(module, exports) {

let $5ae177c72d819b7b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5ae177c72d819b7b$var$load("hhss7"),
    $5ae177c72d819b7b$var$load("cqNU4")
]).then(()=>parcelRequire('9c4UU'));

});

parcelRegister("dQXFR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $a7b8dfb125d18cb3$export$a74c7df2718eaab3 = ({ pageId: pageId, updateDocument: updateDocument, isArchived: isArchived, setHoverProps: setHoverProps, onCommentButtonMount: onCommentButtonMount })=>/*#__PURE__*/ (0, $cozmU.memo)((props)=>{
        const { range: range, isWithinRange: isWithinRange, wrapperDOM: wrapperDOM, isAnnotationAllowed: isAnnotationAllowed, onCreate: onCreate, onClose: onClose, applyDraftMode: applyDraftMode, removeDraftMode: removeDraftMode } = props;
        const handleClose = (0, $cozmU.useCallback)(()=>{
            onClose();
            setHoverProps(null);
        }, [
            onClose
        ]);
        (0, $cozmU.useEffect)(()=>{
            setHoverProps({
                pageId: pageId,
                updateDocument: updateDocument,
                isArchived: isArchived,
                range: range,
                wrapperDOM: wrapperDOM,
                isAnnotationAllowed: isAnnotationAllowed,
                onCreate: onCreate,
                onClose: handleClose,
                applyDraftMode: applyDraftMode,
                removeDraftMode: removeDraftMode,
                isWithinRange: isWithinRange,
                onCommentButtonMount: onCommentButtonMount
            });
        // We only want to listen to changes that signifies a new selection
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            range,
            wrapperDOM,
            isWithinRange
        ]);
        return null;
    });
module.exports["HoverManager"] = $a7b8dfb125d18cb3$export$a74c7df2718eaab3;

});

parcelRegister("9zMAu", function(module, exports) {

var $bA6ND = parcelRequire("bA6ND");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");

const $74bbf8cfd9a1c35f$var$useActiveInlineDataActiveInlineDataQuery = (0, $bA6ND.default);
const $74bbf8cfd9a1c35f$export$b1ae1d74e0f8721d = (contentId)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($74bbf8cfd9a1c35f$var$useActiveInlineDataActiveInlineDataQuery, {
        variables: {
            cloudId: cloudId,
            contentId: `ari:cloud:confluence:${cloudId}:${contentType === 'blogpost' ? 'blogpost' : 'page'}/${contentId}`
        },
        skip: !(0, $6mKj3.expVal)('confluence_inline_reactions', 'isEnabled', false),
        __callerPackage__: "experiment-inline-reactions"
    });
    return (0, $cozmU.useMemo)(()=>{
        const reactions = data?.confluence_activeInlineData?.reactions ?? [];
        const reactionMarkerRefs = [];
        const reactionMarkerMap = reactions.reduce((acc, marker)=>{
            if (marker) {
                reactionMarkerRefs.push(marker.markerRef);
                acc[marker.markerRef] = marker.commentId;
            }
            return acc;
        }, {});
        return {
            reactionMarkerRefs: reactionMarkerRefs,
            reactionMarkerMap: reactionMarkerMap,
            loading: loading,
            error: error
        };
    }, [
        data,
        loading,
        error
    ]);
};
module.exports["useActiveInlineData"] = $74bbf8cfd9a1c35f$export$b1ae1d74e0f8721d;

});

parcelRegister("bA6ND", function(module, exports) {
/**
 * @generated SignedSource<<428d5d05389190f3430e2e55e0611abb>>
 * @relayHash 489e47f009d264a94dcf13fd8bbf4da5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bdb31f2f6d397ed61363226785e1134c6f4c380caf11e97e782427d2c1885515
const $2d165df3d65dbb71$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ConfluenceActiveInlineData",
            "kind": "LinkedField",
            "name": "confluence_activeInlineData",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceInlineMarker",
                    "kind": "LinkedField",
                    "name": "reactions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "commentId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "markerRef"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useActiveInlineDataActiveInlineDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useActiveInlineDataActiveInlineDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "489e47f009d264a94dcf13fd8bbf4da5",
            "id": "bdb31f2f6d397ed61363226785e1134c6f4c380caf11e97e782427d2c1885515",
            "metadata": {},
            "name": "useActiveInlineDataActiveInlineDataQuery",
            "operationKind": "query",
            "text": "query useActiveInlineDataActiveInlineDataQuery($cloudId:ID!,$contentId:ID!){confluence_activeInlineData(cloudId:$cloudId,contentId:$contentId){reactions{commentId,markerRef,type}}}"
        }
    };
}();
$2d165df3d65dbb71$var$node.hash = "1068a88ea8d0dcc33a5206b8fda71604";
var $2d165df3d65dbb71$export$2e2bcd8739ae039 = $2d165df3d65dbb71$var$node;
module.exports["default"] = $2d165df3d65dbb71$export$2e2bcd8739ae039;

});

parcelRegister("ikqOG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dklIa = parcelRequire("dklIa");

const $ca333d186b666e4b$export$fc080b9f1ca96cbc = ({ reactionMarkerRefs: reactionMarkerRefs, reactionMarkerMap: reactionMarkerMap })=>{
    const optimisticReactionMarkerMap = (0, $dklIa.useOptimisticReactionMarkerMap)();
    const optimisticResolvedMarkerRefs = (0, $dklIa.useOptimisticResolvedMarkerRefs)();
    const optimisticDeletedMarkerRefs = (0, $dklIa.useOptimisticDeletedMarkerRefs)();
    const { pruneOptimisticReactions: pruneOptimisticReactions, pruneOptimisticResolvedMarkerRefs: pruneOptimisticResolvedMarkerRefs, pruneOptimisticDeletedMarkerRefs: pruneOptimisticDeletedMarkerRefs } = (0, $dklIa.useInlineReactionActions)();
    const optimisticResolvedMarkerRefList = (0, $cozmU.useMemo)(()=>Array.from(optimisticResolvedMarkerRefs), [
        optimisticResolvedMarkerRefs
    ]);
    // Drain optimistic entries once the server-confirmed map contains them so
    // the optimistic store does not grow unbounded. `pruneOptimisticReactions`
    // is itself a no-op when nothing needs pruning.
    // Also drain resolved refs once the server no longer returns them.
    (0, $cozmU.useEffect)(()=>{
        const serverKeys = Object.keys(reactionMarkerMap);
        if (serverKeys.length > 0) pruneOptimisticReactions(serverKeys);
        // Only drain resolved refs when the server has returned data — an empty
        // reactionMarkerRefs during initial load would otherwise immediately clear
        // all optimistic-resolved refs, causing the highlight to reappear when
        // server data lands.
        if (reactionMarkerRefs.length > 0) {
            pruneOptimisticResolvedMarkerRefs(reactionMarkerRefs);
            pruneOptimisticDeletedMarkerRefs(reactionMarkerRefs);
        }
    }, [
        reactionMarkerMap,
        reactionMarkerRefs,
        pruneOptimisticReactions,
        pruneOptimisticResolvedMarkerRefs,
        pruneOptimisticDeletedMarkerRefs
    ]);
    const mergedReactionMarkerMap = (0, $cozmU.useMemo)(()=>{
        const hasOptimistic = Object.keys(optimisticReactionMarkerMap).length > 0;
        const hasResolved = optimisticResolvedMarkerRefs.size > 0;
        const hasDeleted = optimisticDeletedMarkerRefs.size > 0;
        if (!hasOptimistic && !hasResolved && !hasDeleted) return reactionMarkerMap;
        // Server map wins on key conflicts.
        const mergedMap = hasOptimistic ? {
            ...optimisticReactionMarkerMap,
            ...reactionMarkerMap
        } : {
            ...reactionMarkerMap
        };
        for (const ref of optimisticResolvedMarkerRefs)delete mergedMap[ref];
        for (const ref of optimisticDeletedMarkerRefs)delete mergedMap[ref];
        return mergedMap;
    }, [
        reactionMarkerMap,
        optimisticReactionMarkerMap,
        optimisticResolvedMarkerRefs,
        optimisticDeletedMarkerRefs
    ]);
    const mergedReactionMarkerRefs = (0, $cozmU.useMemo)(()=>{
        const optimisticRefs = Object.keys(optimisticReactionMarkerMap);
        const hasOptimistic = optimisticRefs.length > 0;
        const hasResolved = optimisticResolvedMarkerRefs.size > 0;
        const hasDeleted = optimisticDeletedMarkerRefs.size > 0;
        if (!hasOptimistic && !hasResolved && !hasDeleted) return reactionMarkerRefs;
        const set = new Set(reactionMarkerRefs);
        for (const ref of optimisticRefs)set.add(ref);
        // Filter out any refs that have been optimistically resolved but not yet
        // removed by the server refetch — prevents stale highlights reappearing.
        for (const ref of optimisticResolvedMarkerRefs)set.delete(ref);
        for (const ref of optimisticDeletedMarkerRefs)set.delete(ref);
        return Array.from(set);
    }, [
        reactionMarkerRefs,
        optimisticReactionMarkerMap,
        optimisticResolvedMarkerRefs,
        optimisticDeletedMarkerRefs
    ]);
    return {
        mergedReactionMarkerRefs: mergedReactionMarkerRefs,
        mergedReactionMarkerMap: mergedReactionMarkerMap,
        optimisticResolvedMarkerRefs: optimisticResolvedMarkerRefList
    };
};
module.exports["useInlineReactionMarkers"] = $ca333d186b666e4b$export$fc080b9f1ca96cbc;

});

parcelRegister("gGHFp", function(module, exports) {

var $joyRP = parcelRequire("joyRP");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $flWvL = parcelRequire("flWvL");


var $7bpSh = parcelRequire("7bpSh");

const $fc42d4eabc71418e$var$UseEditorContentModeValueQuery = (0, $joyRP.default);
function $fc42d4eabc71418e$export$6bb080aad8c6a96a({ contentId: contentId, isArchived: isArchived }) {
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const isDraft = !isLivePage && Boolean(isEditorPage);
    const status = (0, $flWvL.queryStatusFor)(isDraft, isArchived);
    const contentModeFragmentData = (0, $cozmU.useContext)((0, $7bpSh.ContentModeFragmentContext));
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($fc42d4eabc71418e$var$UseEditorContentModeValueQuery, {
        variables: {
            contentId: contentId,
            isDraft: isDraft,
            status: [
                status
            ]
        },
        fetchPolicy: 'cache-and-network',
        skip: !contentId || Boolean(contentModeFragmentData) // avoid starting network flow
        ,
        __callerPackage__: "editor-content-mode-button"
    });
    let serverModeRaw;
    const contentProps = contentModeFragmentData ? contentModeFragmentData?.contentProperties : data?.content?.nodes?.[0]?.contentProperties;
    if (isDraft) serverModeRaw = contentProps?.draft?.contentMode;
    else serverModeRaw = contentProps?.latest?.contentMode;
    const mode = (0, $flWvL.serverToUiContentMode)(serverModeRaw);
    return (0, $cozmU.useMemo)(()=>({
            mode: mode,
            isLoading: contentModeFragmentData ? false : Boolean(loading),
            error: contentModeFragmentData ? null : error ?? null
        }), [
        mode,
        loading,
        error,
        contentModeFragmentData
    ]);
}
module.exports["useEditorContentModeValue"] = $fc42d4eabc71418e$export$6bb080aad8c6a96a;

});

parcelRegister("joyRP", function(module, exports) {
/**
 * @generated SignedSource<<11e8316517ac59e0b0326a7aa3a855c6>>
 * @relayHash ff452defe6c30c6aef6cb69359d0b5a9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad
const $fd020ad5a5ea36ff$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDraft"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "contentMode"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "concreteType": "PublishedContentProperties",
                                            "kind": "LinkedField",
                                            "name": "latest",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "DraftContentProperties",
                                            "kind": "LinkedField",
                                            "name": "draft",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ff452defe6c30c6aef6cb69359d0b5a9",
            "id": "34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad",
            "metadata": {},
            "name": "useEditorContentModeValueQuery",
            "operationKind": "query",
            "text": "query useEditorContentModeValueQuery($contentId:ID!,$isDraft:Boolean!,$status:[String]){content(id:$contentId,status:$status){nodes{id,contentProperties{latest@skip(if:$isDraft){contentMode},draft@include(if:$isDraft){contentMode}}}}}"
        }
    };
}();
$fd020ad5a5ea36ff$var$node.hash = "51a479801516afe1b59a1bbcd1c3f7d5";
var $fd020ad5a5ea36ff$export$2e2bcd8739ae039 = $fd020ad5a5ea36ff$var$node;
module.exports["default"] = $fd020ad5a5ea36ff$export$2e2bcd8739ae039;

});

parcelRegister("flWvL", function(module, exports) {
const $601c87545eb15d39$export$7744ef788ce8060b = (server)=>{
    if (typeof server === 'string') {
        const v = server.toLowerCase();
        if (v === 'compact') return 'compact';
    }
    return 'standard';
};
const $601c87545eb15d39$export$c21c52065fb17015 = (ui)=>ui === 'compact' ? 'COMPACT' : 'STANDARD';
const $601c87545eb15d39$export$9b5b746082006bde = (m)=>m === 'compact' ? 'standard' : 'compact';
const $601c87545eb15d39$export$bc47da214dd10736 = (opts)=>{
    if (opts.isLivePage) return 'CURRENT';
    if (opts.isEditorPage) return 'DRAFT';
    return 'CURRENT';
};
const $601c87545eb15d39$export$7052ab1304ba8160 = (isDraft, isArchived)=>{
    return isArchived ? 'archived' : isDraft ? 'draft' : 'current';
};
module.exports["serverToUiContentMode"] = $601c87545eb15d39$export$7744ef788ce8060b;
module.exports["uiToServerContentMode"] = $601c87545eb15d39$export$c21c52065fb17015;
module.exports["flipContentMode"] = $601c87545eb15d39$export$9b5b746082006bde;
module.exports["resolveContentStatus"] = $601c87545eb15d39$export$bc47da214dd10736;
module.exports["queryStatusFor"] = $601c87545eb15d39$export$7052ab1304ba8160;

});

parcelRegister("dANtQ", function(module, exports) {

var $i1slQ = parcelRequire("i1slQ");


var $6ozxE = parcelRequire("6ozxE");



var $jtuBN = parcelRequire("jtuBN");

const $be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery = (0, $i1slQ.default);
const $be6154107952d370$var$noOpRefetch = ()=>Promise.resolve();
const $be6154107952d370$export$4cae5d8963399c48 = (contentId, // Retained for callers that pass preloaded permissions as the third argument.
_cacheOnly = false, preloadedCanAddComments)=>{
    const baseOptions = {
        skip: !contentId || preloadedCanAddComments !== undefined
    };
    const status = [
        'draft',
        'current'
    ];
    const { data: data, loading: loading, error: error, networkStatus: networkStatus } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery, {
        ...baseOptions,
        variables: {
            contentId: contentId,
            status: status
        },
        skipFetchIfCached: false,
        __callerPackage__: "comments-hooks"
    });
    const createPermission = (0, $6ozxE.canAddCommentsFromOperations)(data?.content?.nodes?.[0]?.operations);
    return {
        canAddComments: preloadedCanAddComments ?? createPermission,
        loading: preloadedCanAddComments === undefined ? loading : false,
        contentQueryError: preloadedCanAddComments === undefined ? error : undefined,
        refetch: $be6154107952d370$var$noOpRefetch,
        networkStatus: networkStatus
    };
};
module.exports["useAddCommentPermissionCheck"] = $be6154107952d370$export$4cae5d8963399c48;

});

parcelRegister("i1slQ", function(module, exports) {
/**
 * @generated SignedSource<<5821fd331c47db168316a2c3a4e69985>>
 * @relayHash f2ed22cac79248fed29ace7669709d01
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 624f6c98a1c2b9a83cb2c19aecdae78adfcdabf9f4d3d08dad00de2c6cff9369
const $fc06507f37418bb6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f2ed22cac79248fed29ace7669709d01",
            "id": "624f6c98a1c2b9a83cb2c19aecdae78adfcdabf9f4d3d08dad00de2c6cff9369",
            "metadata": {},
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "operationKind": "query",
            "text": "query useAddCommentPermissionCheckPermissionCheckAddCommentQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$fc06507f37418bb6$var$node.hash = "60c40f4780bf1c488b0028e9d219e3d4";
var $fc06507f37418bb6$export$2e2bcd8739ae039 = $fc06507f37418bb6$var$node;
module.exports["default"] = $fc06507f37418bb6$export$2e2bcd8739ae039;

});

parcelRegister("6ozxE", function(module, exports) {

var $lfBMY = parcelRequire("lfBMY");

const $b3568511a7ce4c14$export$f67dec4694484421 = (operations)=>operations?.some((operation)=>operation?.operation === (0, $lfBMY.OperationTypes).CREATE && operation?.targetType === 'comment') ?? false;
module.exports["canAddCommentsFromOperations"] = $b3568511a7ce4c14$export$f67dec4694484421;

});

parcelRegister("2TjtA", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $hRnS5 = parcelRequire("hRnS5");


var $8Kasn = parcelRequire("8Kasn");


var $hEeUR = parcelRequire("hEeUR");


var $6mKj3 = parcelRequire("6mKj3");


var $e4o8D = parcelRequire("e4o8D");


var $7oNjV = parcelRequire("7oNjV");


var $hBmKH = parcelRequire("hBmKH");


var $KndLU = parcelRequire("KndLU");

const $37b1f85e2c625feb$var$DEFAULT_DOCUMENT = {
    version: 1,
    type: 'doc',
    content: [
        {
            type: 'paragraph',
            content: []
        }
    ]
};
const $37b1f85e2c625feb$export$bfa9bef3db8b5c11 = (node)=>({
        adfDocument: node?.parameters?.nestedContent || $37b1f85e2c625feb$var$DEFAULT_DOCUMENT,
        appearance: (0, $6mKj3.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $6mKj3.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? 'max' : 'full-width'
    });
const $37b1f85e2c625feb$var$collapsedEmptyLists = null;
const $37b1f85e2c625feb$var$stableTableHydrationLayout = null;
const $37b1f85e2c625feb$export$c71052e15da9d2c0 = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { allowAnnotations: allowAnnotations, annotationProvider: annotationProvider, appearance: appearance, contentId: contentId, contentMode: contentMode, dataProviders: dataProviders, adfDocument: adfDocument, eventHandlers: eventHandlers, extensionHandlers: extensionHandlers, onSetLinkTarget: onSetLinkTarget } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            skipValidation: true
        };
        $[0] = t1;
    } else t1 = $[0];
    const validationContextValue = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_4ixK1yYbGa _4hO0hfYbGa _44jcBZdnbC _3tyuUtdnbC",
            "_0glMfrogpp _0awIj60ATe"
        ]);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== adfDocument || $[3] !== allowAnnotations || $[4] !== annotationProvider || $[5] !== appearance || $[6] !== contentId || $[7] !== contentMode || $[8] !== dataProviders || $[9] !== eventHandlers || $[10] !== extensionHandlers || $[11] !== onSetLinkTarget) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Kasn.ValidationContextProvider), {
            value: validationContextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hEeUR.ADFRenderer), {
            annotationProvider: annotationProvider,
            allowAnnotations: allowAnnotations,
            appearance: appearance,
            allowHeadingAnchorLinks: false,
            contentId: contentId,
            dataProviders: dataProviders,
            document: adfDocument,
            extensionHandlers: extensionHandlers,
            contentMode: contentMode,
            eventHandlers: eventHandlers,
            onSetLinkTarget: onSetLinkTarget
        }))));
        $[2] = adfDocument;
        $[3] = allowAnnotations;
        $[4] = annotationProvider;
        $[5] = appearance;
        $[6] = contentId;
        $[7] = contentMode;
        $[8] = dataProviders;
        $[9] = eventHandlers;
        $[10] = extensionHandlers;
        $[11] = onSetLinkTarget;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
}; /**
    * Server/first-hydration renderer for the non-recursive LCM SSR path. It intentionally avoids the
    * client provider hooks because they can start queries that are unnecessary when no nested
    * extension is present, and it passes no nested handlers: without recursive SSR there is nothing
    * inside the LCM that the SSR handler set would own.
    */ 
const $37b1f85e2c625feb$export$68180e79369d4d34 = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { contentId: contentId, contentMode: contentMode, node: node } = t0;
    let t1;
    if ($[0] !== node) {
        t1 = $37b1f85e2c625feb$export$bfa9bef3db8b5c11(node);
        $[0] = node;
        $[1] = t1;
    } else t1 = $[1];
    const { adfDocument: adfDocument, appearance: appearance } = t1;
    let t2;
    if ($[2] !== adfDocument || $[3] !== appearance || $[4] !== contentId || $[5] !== contentMode) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($37b1f85e2c625feb$export$c71052e15da9d2c0, {
            adfDocument: adfDocument,
            appearance: appearance,
            contentId: contentId,
            contentMode: contentMode
        });
        $[2] = adfDocument;
        $[3] = appearance;
        $[4] = contentId;
        $[5] = contentMode;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
}); /**
     * Keeps the nested ADFRenderer mounted across the SSR-handler to manifest-ready handoff. The first
     * client render uses exactly the server configuration; client-only providers are attached in place
     * only after both Confluence hydration and the LCM manifest preload have completed.
     *
     * `dataProviders` is deliberately NOT deferred with the rest of the client config. Nested extensions
     * reach their manifests through the factory's `extensionProvider`, and platform's `WithProviders`
     * subscribes in its constructor without ever re-subscribing, so a factory attached after mount can
     * never reach the extensions already rendered — every `null`-returning handler would be left with a
     * dead fall-through and no way to reach the manifest. The factory is therefore supplied from the
     * very first render, on the server and on the client alike, so both sides agree.
     */ 
const $37b1f85e2c625feb$export$7fbd5941a148d056 = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { clientAnnotationProvider: clientAnnotationProvider, clientExtensionHandlers: clientExtensionHandlers, clientHydrationReady: clientHydrationReady, contentId: contentId, contentMode: contentMode, extensionHandlers: extensionHandlers, node: node } = t0;
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const [clientConfig, setClientConfig] = (0, $cozmU.useState)();
    let t1;
    if ($[0] !== node) {
        t1 = $37b1f85e2c625feb$export$bfa9bef3db8b5c11(node);
        $[0] = node;
        $[1] = t1;
    } else t1 = $[1];
    const { adfDocument: adfDocument, appearance: appearance } = t1;
    const dataProviders = (0, $KndLU.useNestedLcmProviderFactory)();
    const shouldLoadClientConfig = clientHydrationReady && !renderServerPlaceholder;
    const t2 = clientConfig?.allowAnnotations;
    const t3 = clientConfig?.annotationProvider;
    const t4 = clientConfig?.eventHandlers;
    const t5 = clientConfig ? clientExtensionHandlers : extensionHandlers;
    const t6 = clientConfig?.onSetLinkTarget;
    let t7;
    if ($[2] !== adfDocument || $[3] !== appearance || $[4] !== contentId || $[5] !== contentMode || $[6] !== dataProviders || $[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($37b1f85e2c625feb$export$c71052e15da9d2c0, {
            adfDocument: adfDocument,
            allowAnnotations: t2,
            annotationProvider: t3,
            appearance: appearance,
            contentId: contentId,
            contentMode: contentMode,
            dataProviders: dataProviders,
            eventHandlers: t4,
            extensionHandlers: t5,
            onSetLinkTarget: t6
        });
        $[2] = adfDocument;
        $[3] = appearance;
        $[4] = contentId;
        $[5] = contentMode;
        $[6] = dataProviders;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== adfDocument || $[14] !== clientAnnotationProvider || $[15] !== contentId || $[16] !== shouldLoadClientConfig) {
        t8 = shouldLoadClientConfig ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7oNjV.NBMRendererHydrationClientEnhancer), {
            adfDocument: adfDocument,
            annotationProvider: clientAnnotationProvider,
            contentId: contentId,
            onLoad: setClientConfig
        }) : null;
        $[13] = adfDocument;
        $[14] = clientAnnotationProvider;
        $[15] = contentId;
        $[16] = shouldLoadClientConfig;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== t7 || $[19] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBmKH.NestedLcmHierarchyContext).Provider, {
            value: true
        }, t7, t8);
        $[18] = t7;
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    return t9;
});
module.exports["resolveNBMRenderConfig"] = $37b1f85e2c625feb$export$bfa9bef3db8b5c11;
module.exports["NBMRendererContent"] = $37b1f85e2c625feb$export$c71052e15da9d2c0;
module.exports["NBMRendererServer"] = $37b1f85e2c625feb$export$68180e79369d4d34;
module.exports["NBMRendererHydrationBridge"] = $37b1f85e2c625feb$export$7fbd5941a148d056;

});

parcelRegister("hBmKH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $822af98a6e50f7f8$export$4775c9f13efbc1b0 = (0, $cozmU.createContext)(false);
module.exports["NestedLcmHierarchyContext"] = $822af98a6e50f7f8$export$4775c9f13efbc1b0;

});

parcelRegister("iy2dR", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $79LXc = parcelRequire("79LXc");

const $b57efbc43dea6d2e$export$5a1bd65a7ea6f802 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { adfDocument: adfDocument, contentId: contentId } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== adfDocument || $[1] !== contentId || $[2] !== createAnalyticsEvent) {
        t1 = ()=>{
            if (!contentId || !createAnalyticsEvent || !adfDocument) return;
            createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    action: "rendererInitialised",
                    actionSubject: "legacyContentMacro",
                    source: "legacyContentMacro",
                    attributes: {
                        objectId: contentId,
                        pageElementCounts: (0, $79LXc.getPageElementCounts)(adfDocument)
                    }
                }
            }).fire();
        };
        t2 = [
            adfDocument,
            contentId,
            createAnalyticsEvent
        ];
        $[0] = adfDocument;
        $[1] = contentId;
        $[2] = createAnalyticsEvent;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
};
module.exports["useLegacyContentMacroRendererAnalytics"] = $b57efbc43dea6d2e$export$5a1bd65a7ea6f802;

});

parcelRegister("KndLU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jB2jW = parcelRequire("jB2jW");


var $eNbr2 = parcelRequire("eNbr2");

const $167fdde8c4be9ce3$var$EXTENSION_PROVIDER = 'extensionProvider';
const $167fdde8c4be9ce3$export$2f22eff5a5f99ed4 = ()=>{
    const $ = (0, $bDgLe.c)(6);
    const parentProviderFactory = (0, $jB2jW.useProviderFactory)();
    let t0;
    if ($[0] !== parentProviderFactory) {
        const readParentExtensionProvider = ()=>{
            const probe = $167fdde8c4be9ce3$var$_temp;
            const provider = parentProviderFactory.subscribe($167fdde8c4be9ce3$var$EXTENSION_PROVIDER, probe);
            parentProviderFactory.unsubscribe($167fdde8c4be9ce3$var$EXTENSION_PROVIDER, probe);
            return provider;
        };
        const inheritedProvider = readParentExtensionProvider();
        t0 = (0, $eNbr2.default).create(inheritedProvider ? {
            [$167fdde8c4be9ce3$var$EXTENSION_PROVIDER]: inheritedProvider
        } : {});
        $[0] = parentProviderFactory;
        $[1] = t0;
    } else t0 = $[1];
    const providerFactory = t0;
    let t1;
    let t2;
    if ($[2] !== parentProviderFactory || $[3] !== providerFactory) {
        t1 = ()=>{
            const forwardExtensionProvider = (_name, provider_0)=>{
                providerFactory.setProvider($167fdde8c4be9ce3$var$EXTENSION_PROVIDER, provider_0);
            };
            parentProviderFactory.subscribe($167fdde8c4be9ce3$var$EXTENSION_PROVIDER, forwardExtensionProvider);
            return ()=>parentProviderFactory.unsubscribe($167fdde8c4be9ce3$var$EXTENSION_PROVIDER, forwardExtensionProvider);
        };
        t2 = [
            parentProviderFactory,
            providerFactory
        ];
        $[2] = parentProviderFactory;
        $[3] = providerFactory;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return providerFactory;
};
function $167fdde8c4be9ce3$var$_temp() {}
module.exports["useNestedLcmProviderFactory"] = $167fdde8c4be9ce3$export$2f22eff5a5f99ed4;

});

parcelRegister("7oNjV", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jNKuq = parcelRequire("jNKuq");


var $iy2dR = parcelRequire("iy2dR");

const $925a9bbfc58ef16a$export$37957a653a6adcbf = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { adfDocument: adfDocument, annotationProvider: annotationProvider, contentId: contentId, onLoad: onLoad } = t0;
    const { eventHandlers: eventHandlers, onSetLinkTarget: onSetLinkTarget } = (0, $jNKuq.useExternalLinkHandlers)();
    let t1;
    if ($[0] !== annotationProvider || $[1] !== eventHandlers || $[2] !== onSetLinkTarget) {
        t1 = {
            allowAnnotations: true,
            annotationProvider: annotationProvider,
            eventHandlers: eventHandlers,
            onSetLinkTarget: onSetLinkTarget
        };
        $[0] = annotationProvider;
        $[1] = eventHandlers;
        $[2] = onSetLinkTarget;
        $[3] = t1;
    } else t1 = $[3];
    const clientConfig = t1;
    let t2;
    let t3;
    if ($[4] !== clientConfig || $[5] !== onLoad) {
        t2 = ()=>{
            onLoad(clientConfig);
        };
        t3 = [
            clientConfig,
            onLoad
        ];
        $[4] = clientConfig;
        $[5] = onLoad;
        $[6] = t2;
        $[7] = t3;
    } else {
        t2 = $[6];
        t3 = $[7];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[8] !== adfDocument || $[9] !== contentId) {
        t4 = {
            adfDocument: adfDocument,
            contentId: contentId
        };
        $[8] = adfDocument;
        $[9] = contentId;
        $[10] = t4;
    } else t4 = $[10];
    (0, $iy2dR.useLegacyContentMacroRendererAnalytics)(t4);
    return null;
};
module.exports["NBMRendererHydrationClientEnhancer"] = $925a9bbfc58ef16a$export$37957a653a6adcbf;

});


//# sourceMappingURL=LegacyContentExtensionHandler.9267f082.js.map
